import { Typography, Icon, styled } from '@nextiva/next-ui-components';

export const StyledPaymentContainer = styled('div')`
  padding-left: 80px;
`;
export const StyledPaymentText = styled(Typography)`
  font-weight: 800;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  margin-bottom: 10px;
`;
export const StyledCreditCardContainer = styled('div')`
  display: flex;
  align-items: center;
`;
export const StyledCreditCardText = styled(Typography)`
  font-weight: 400;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 20px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  margin-right: 10px;
`;
export const StyledPaymentIcon = styled(Icon)`
  fill: #758ba3;
  margin-right: 12px;
`;
export const StyledHelpIcon = styled(Icon)`
  fill: #758ba3;
  transform: scale(0.75);
`;
export const StyledExpiredText = styled(Typography)`
  margin-top: 2px;
  color: ${({ theme }) => theme.palette.error.dark};
`;
